// Curated sample decklist for the "Try an example" affordance on the bracket
// analyzer. This is demo UI content (a real, well-known mono-red Krenko goblins
// list, 100 cards), NOT card-detection logic - it just gives a first-time user a
// one-tap way to see a real bracket result. Tweak freely.
export const EXAMPLE_DECK_COMMANDER = 'Krenko, Mob Boss'

export const EXAMPLE_DECK = `1 Krenko, Mob Boss *CMDR*
1 Goblin Chieftain
1 Goblin King
1 Goblin Warchief
1 Goblin Rabblemaster
1 Goblin Piledriver
1 Legion Loyalist
1 Skirk Prospector
1 Goblin Recruiter
1 Goblin Matron
1 Siege-Gang Commander
1 Beetleback Chief
1 Mogg War Marshal
1 Goblin Instigator
1 Goblin Trashmaster
1 Pashalik Mons
1 Conspicuous Snoop
1 Muxus, Goblin Grandee
1 Goblin Sharpshooter
1 Reckless Bushwhacker
1 Goblin Bushwhacker
1 Legion Warboss
1 Krenko, Tin Street Kingpin
1 Purphoros, God of the Forge
1 Goblin Chirurgeon
1 Mogg Fanatic
1 Goblin Lackey
1 Goblin Ringleader
1 Frenzied Goblin
1 Goblin Cratermaker
1 Hellrider
1 Goblin Sledder
1 Spikeshot Goblin
1 Goblin Wardriver
1 Battle Cry Goblin
1 Krenko's Command
1 Dragon Fodder
1 Hordeling Outburst
1 Faithless Looting
1 Light Up the Stage
1 Vandalblast
1 Blasphemous Act
1 Chaos Warp
1 Abrade
1 Lightning Bolt
1 Tarfire
1 Coat of Arms
1 Shared Animosity
1 Impact Tremors
1 Goblin Bombardment
1 Fervor
1 Cavalcade of Calamity
1 Hammer of Purphoros
1 Outpost Siege
1 Goblin War Drums
1 Sol Ring
1 Arcane Signet
1 Fellwar Stone
1 Mind Stone
1 Wayfarer's Bauble
1 Skullclamp
1 Lightning Greaves
1 Swiftfoot Boots
1 Quietus Spike
1 Sword of the Animist
1 Throne of the God-Pharaoh
1 Command Tower
1 Rogue's Passage
1 Castle Embereth
1 Buried Ruin
30 Mountain`
